export const PDF_SUFFIX = '(PDF)';
